// extracted by mini-css-extract-plugin
module.exports = {"encodedData":"styles_encodedData__a0YR1"};